import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconRegularDuplicate = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 25,
	viewBox: "0 0 24 25",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M16 1.315H4c-1.1 0-2 .907-2 2.016v14.11h2V3.33h12V1.315zm-1 4.031 6 6.048v10.078c0 1.11-.9 2.016-2 2.016H7.99c-1.1 0-1.99-.907-1.99-2.016l.01-14.11c0-1.108.89-2.016 1.99-2.016h7zm-1 7.056h5.5L14 6.858v5.544z",
		fill: "currentColor",
		fillRule: "evenodd"
	})
});
export default SvgIconRegularDuplicate;
